module.exports = __webpack_public_path__ + "img/partfour_pic4.c8c14029.png";